/**
 * React Query hook for Platform Dashboard Stats
 * 
 * Fetches platform-wide statistics for the system dashboard.
 * This is an admin-only endpoint.
 */

import { useQuery } from '@tanstack/react-query';
import { rawApi } from '@/lib/api-client';
import type { PlatformStats } from '../types';

const PLATFORM_STATS_KEY = ['system', 'dashboard', 'stats'];

/**
 * Fetch platform-wide dashboard statistics
 */
export function usePlatformStats() {
  return useQuery({
    queryKey: PLATFORM_STATS_KEY,
    queryFn: async () => {
      const response = await rawApi.get<PlatformStats>('system/dashboard/stats');
      return response.data;
    },
    staleTime: 60 * 1000, // 1 minute
    refetchInterval: 60 * 1000, // Refetch every minute
  });
}
